const INITIAL_STATE = {
    item : null,
    errors_message: null,
}

const merchantReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case 'FETCHSCHEDULE' :
            return{
                ...state,
                item: action.payload
            }
        case 'ERR_FETCH_SCHEDULE' : 
            return{
                ...state,
                errors_message:action.payload
            }
        case 'REMOVE_ERR_FETCH_SCHEDULE' : 
            return{
                ...state,
                errors_message: null
            }
        default : 
            return state
    }
}

export default merchantReducer